import React from "react";
import FondoMisionHuemul from "../images/Fondos/FondoMisionHuemul.jpg";

const MisionSection = () => {
  return (
    <section
      id="mision"
      className="relative w-full py-12 md:py-24 lg:py-32 text-white overflow-hidden"
    >
      {/* Fondo con imagen y gradiente */}
      <div className="absolute inset-0 z-0">
        <img
          src={FondoMisionHuemul}
          alt="Fondo Huemul Animal"
          className="object-cover w-full h-full object-left md:object-right scale-100"
        />
        <div 
          className="absolute inset-0 hidden md:block"
          style={{
            background: `
              linear-gradient(90deg, transparent 0%, transparent 25%, rgba(20, 24, 54, 0.95) 65%)
            `
          }}
        />
      </div>

      {/* Contenido */}
      <div className="container relative z-10 mx-auto px-4 md:px-6 flex justify-end">
        <div className="max-w-[600px] text-right">
          <h2 className="text-2xl font-bold mb-12">
            MISIÓN, VISIÓN Y VALORES
          </h2>
          
          <div className="space-y-8">
            <div>
              <p className="text-base font-thin">
                <span className="font-bold">Tenemos la misión</span> de ofrecer un servicio responsable y eficiente, 
                que satisfaga las necesidades de nuestros clientes con 
                responsabilidad y compromiso sostenible en el tiempo.
              </p>
            </div>

            <div>
              <p className="text-xl font-thin">
                <span className="font-bold">Nacimos con la visión</span> de posicionarnos como una de las 
                empresas más importantes de transporte de carga principalmente 
                en el sector agropecuario, logrando un constante crecimiento 
                y desarrollo para explorar otros nichos de mercado.
              </p>
            </div>

            <div>
              <p className="text-xl font-thin">
                <span className="font-bold">Nuestros valores</span> son el compromiso, la excelencia, la seguridad, 
                y la integridad, fruto del trabajo en equipo y el trato siempre 
                cercano con todo nuestro ecosistema de trabajo.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MisionSection;
